module.exports = __webpack_public_path__ + "img/complete@2x.98ec45ee.png";